import React from 'react';
import { Mail } from 'lucide-react';

interface LogoIconProps {
  size?: 'sm' | 'md' | 'lg';
}

const LogoIcon: React.FC<LogoIconProps> = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-10 w-10 rounded-xl',
    md: 'h-12 w-12 rounded-xl',
    lg: 'h-16 w-16 rounded-2xl'
  };

  const iconSizes = {
    sm: 'h-5 w-5',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  return (
    <div className={`relative ${sizes[size]} flex items-center justify-center bg-gradient-to-br from-blue-500 via-cyan-500 to-emerald-400 shadow-[0_0_24px_-4px_rgba(34,211,238,0.6)] transition-transform duration-300 group-hover:rotate-6`}>
      <div className="absolute inset-[1.5px] rounded-[inherit] bg-slate-950/85" />
      <Mail className={`relative ${iconSizes[size]} text-cyan-300`} strokeWidth={2.25} />
      <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-emerald-400 ring-2 ring-slate-950" />
    </div>
  );
};

export default LogoIcon;
